<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <tabs-desktop :ranking="ranking"
                      :selected="selected"
                      :set-ranking="setRanking"></tabs-desktop>
        <tabs-mobile :ranking="ranking"
                     :selected="selected"
                     :set-ranking="setRanking"></tabs-mobile>
        <ranking-table :ranking="ranking"
                       :selected="selected"></ranking-table>
    </b-col>
</template>

<script>
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue';
    import RankingTable from './top-qualified/RankingTable';
    import TabsDesktop from './top-qualified/TabsDesktop';
    import TabsMobile from './top-qualified/TabsMobile';

    export default {
        components: { FuturocoinsFromMining, RankingTable, TabsDesktop, TabsMobile },
        data () {
            return {
                ranking: {
                    vip: {
                        code: 'vip',
                        name: 'VIP'
                    },
                    diamond_2: {
                        code: 'diamond_2',
                        name: '2** DIAMOND'
                    },
                    diamond_1: {
                        code: 'diamond_1',
                        name: '1* DIAMOND'
                    },
                    diamond: {
                        code: 'diamond',
                        name: 'DIAMOND'
                    },
                    gold: {
                        code: 'gold',
                        name: 'GOLD'
                    },
                    silver: {
                        code: 'silver',
                        name: 'SILVER'
                    },
                    bronze: {
                        code: 'bronze',
                        name: 'BRONZE'
                    }
                },
                selected: 'vip'
            }
        },
        methods: {
            setRanking (rankingCode) {
                if (this.ranking[rankingCode]) {
                    this.selected = this.ranking[rankingCode].code;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/TopQualifiedContent.vue